import React from 'react';

// Styles & Assets
import styles from './ScorePage.module.css';

// Components
import Toolbar from '../../components/UI/Toolbar/Toolbar';
import ScoreTableParams from '../../components/Scores/ScoreTableParams/ScoreTableParams';
import ScoreRulesView from '../../components/Scores/ScoreRulesView/ScoreRulesView';
import AlertRulesView from '../../components/Scores/AlertRulesView/AlertRulesView';

// Interfaces
import { Score } from '../../interfaces/Score';

// Language
import { useTranslation } from 'react-i18next';

// Other
import { useLocation } from 'react-router-dom';

// ScoreTablePage: page that renders a toolbar and a table of a specific score.
const ScorePage: React.FC = () => {

    const location = useLocation();
    const score: Score = location.state.score;

    const { t } = useTranslation();

    return (
        <div className={styles.scoresContainer}>
            <Toolbar text={t('scores') as string} link='/home/administration/scores_management' />
            <div className={styles.scoreContainer}>
                <h1>{score.name}</h1>
                <div className={styles.scoreContent}>
                    {score.score_parameters.length > 0 &&
                        <ScoreTableParams scoreParameters={score.score_parameters} />
                    }
                    {score.score_rules &&
                        <ScoreRulesView scoreRules={score.score_rules} />
                    }
                    {score.score_alerts &&
                        <AlertRulesView alerts={score.score_alerts} />
                    }
                </div>
            </div>
        </div>
    );
};

export default ScorePage;